/**
 * 车辆基本信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
Mock.mock(/\/used_car\/ticket\/car_info\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    car_info: {
      'id|+1': 1,
      transfer_count: 1, // 过户次数
      last_transfer_date: '2017-12-12', // 最后过户时间
      vin: 'WDBGP57B6PB127810', // 车架号
      car_model_id: 1, // 车型id
      car_model_name: '车型描述', // 车型名称
      mileage: 100000, // 里程
      color_id: 1, // 车身颜色id
      color_name: '黑', // 车身颜色名称
      is_color_changed: true, // 是否变更过车身颜色 (布尔值)
      production_date: '2017-12-12', // 车辆出厂时间
      license_issued_on: '2017-12-12', // 车辆上牌时间
      belonged_province: '北京市', // 车辆归属地省份
      belonged_province_code: '110000', // 车辆归属地省份code
      belonged_city: '北京市辖区', // 车辆归属地城市
      belonged_city_code: '110100', // 车辆归属地城市code
      located_province: '天津市', // 车辆所在地省份
      located_province_code: '120000', // 车辆所在地省份code
      located_city: '天津市辖区', // 车辆所在地城市
      located_city_code: '120100', // 车辆所在地城市code
      plate_number: '粤A', // 车牌号
      is_refitted: 1, // 车辆是否改装过 1是 0否
      car_character: 1, // 车辆性质id (可以查看文档中的性质列表对照)
      car_character_name: '公户', // 车辆性质名
      usage_character: 1, // 车辆使用性质id (可以查看文档中的车辆使用性质列表对照)
      usage_character_name: '营运', // 车辆使用性质名
      emission_standard: 1, // 排放标准id  (可以查看文档中的排放标准列表对照)
      emission_standard_name: '国五', // 排放标准名称
      note: '备注', // 备注信息
      'info': {
        'config': [
          {
            'group_name': 'basic',
            'name': '基本参数',
            'params': [
              {
                'name': '车门数(个)',
                'external_name': 'Body_Doors',
                'value': null
              },
              {
                'name': '座位数(个)',
                'external_name': 'Perf_SeatNum',
                'value': null
              },
              {
                'name': '排量(L)',
                'external_name': 'Engine_ExhaustForFloat',
                'value': null
              },
              {
                'name': '燃料类型',
                'external_name': 'Oil_FuelType',
                'value': null
              },
              {
                'name': '挡位个数(个)',
                'external_name': 'UnderPan_ForwardGearNum',
                'value': null
              },
              {
                'name': '变速箱类型',
                'external_name': 'UnderPan_TransmissionType',
                'value': null
              },
              {
                'name': '驱动方式',
                'external_name': 'Perf_DriveType',
                'value': null
              }
            ]
          },

          {
            'group_name': 'security',
            'name': '主/被动安全设备',
            'params': [
              {
                'name': '驾驶位安全气囊',
                'external_name': 'Safe_DriverGasBag',
                'value': null
              },
              {
                'name': '副驾驶位安全气囊',
                'external_name': 'Safe_SubDriverGasBag',
                'value': null
              },
              {
                'name': '前排侧安全气囊',
                'external_name': 'Safe_FsadGasbag',
                'value': null
              },
              {
                'name': '后排侧安全气囊',
                'external_name': 'Safe_BsadGasbag',
                'value': null
              },
              {
                'name': '前排头部气囊(气帘)',
                'external_name': 'Safe_FheadGasbag',
                'value': null
              },
              {
                'name': '膝部气囊',
                'external_name': 'Safe_KneeGasBag',
                'value': null
              },
              {
                'name': '安全带气囊',
                'external_name': 'InStat_BeltBag',
                'value': null
              },
              {
                'name': '胎压监测装置',
                'external_name': 'UnderPan_TyrePressureWatcher',
                'value': null
              },
              {
                'name': '刹车防抱死(ABS)',
                'external_name': 'Safe_ABS',
                'value': null
              },
              {
                'name': '盲点检测/并线辅助',
                'external_name': 'InStat_blindspotdetection',
                'value': null
              },
              {
                'name': '夜视系统',
                'external_name': 'InStat_NightVisionSystem',
                'value': null
              }
            ]
          },

          {
            'group_name': 'accessory',
            'name': '辅助/操控配置',
            'params': [
              {
                'name': '泊车雷达(车前)',
                'external_name': 'UnderPan_PRadar',
                'value': null
              },
              {
                'name': '倒车雷达(车后)',
                'external_name': 'UnderPan_RRadar',
                'value': null
              },
              {
                'name': '倒车影像',
                'external_name': 'UnderPan_RImage',
                'value': null
              },
              {
                'name': '全景摄像头',
                'external_name': 'InStat_PanoramicCamera',
                'value': null
              },
              {
                'name': '定速巡航',
                'external_name': 'InStat_SpeedCruise',
                'value': null
              },
              {
                'name': '自适应巡航',
                'external_name': 'InStat_Automaticcruise',
                'value': null
              },
              {
                'name': '自动泊车入位',
                'external_name': 'InStat_AutoParking',
                'value': null
              },
              {
                'name': '上坡辅助',
                'external_name': 'InStat_UphillAuxiliary',
                'value': null
              },
              {
                'name': '自动驻车',
                'external_name': 'InStat_AutoPark',
                'value': null
              },
              {
                'name': '陡坡缓降',
                'external_name': 'InStat_HDC',
                'value': null
              },
              {
                'name': '遥控驾驶',
                'external_name': 'Safe_Remotedriving',
                'value': null
              }
            ]
          },

          {
            'group_name': 'external',
            'name': '外部/防盗配置',
            'params': [
              {
                'name': '天窗型式',
                'external_name': 'Body_Louver',
                'value': null
              },
              {
                'name': '运动外观套件',
                'external_name': 'OutStat_SportsAppearanceKit',
                'value': null
              },
              {
                'name': '铝合金轮圈',
                'external_name': 'Aluminum_alloy_wheels # 没有标明',
                'value': null
              },
              {
                'name': '感应行李厢',
                'external_name': 'Induction_trunk',
                'value': null
              },
              {
                'name': '车顶行李箱架',
                'external_name': 'OutStat_TopSnelf',
                'value': null
              },
              {
                'name': '无钥匙启动系统',
                'external_name': 'InStat_AIgnitionSys',
                'value': null
              },
              {
                'name': '无钥匙进入系统',
                'external_name': 'nokey_into',
                'value': null
              },
              {
                'name': '遥控启动',
                'external_name': 'InStat_RemoteStart',
                'value': null
              },
              {
                'name': '后导流尾翼',
                'external_name': 'OutStat_InductEmpennage',
                'value': null
              }
            ]
          },

          {
            'group_name': 'internal',
            'name': '内部配置',
            'params': [
              {
                'name': '多功能方向盘',
                'external_name': 'InStat_MultiFuncSteer',
                'value': null
              },
              {
                'name': '换挡拨片',
                'external_name': 'InStat_SteerEtc',
                'value': null
              },
              {
                'name': '方向盘加热',
                'external_name': 'Steering_Wheel_hot',
                'value': null
              },
              {
                'name': '方向盘记忆设置',
                'external_name': 'InStat_SteerMomery',
                'value': null
              },
              {
                'name': '方向盘表面材料',
                'external_name': 'InStat_SteerMaterial',
                'value': null
              },
              {
                'name': 'HUD抬头数字显示',
                'external_name': 'InStat_Hud',
                'value': null
              }
            ]
          },

          {
            'group_name': 'seat',
            'name': '座椅配置',
            'params': [
              {
                'name': '座椅材料',
                'external_name': 'InStat_SeatMaterial',
                'value': null
              },
              {
                'name': '运动座椅',
                'external_name': 'InStat_SportSeat',
                'value': null
              },
              {
                'name': '驾驶座腰部支撑调节',
                'external_name': 'InStat_DSeatProp',
                'value': null
              },
              {
                'name': '驾驶座肩部支撑调节',
                'external_name': 'InStat_AdjustableShoulderSupport',
                'value': null
              },
              {
                'name': '驾驶座座椅调节方式',
                'external_name': 'InStat_DSeatTuneType',
                'value': null
              },
              {
                'name': '副驾驶座椅调节方式',
                'external_name': 'InStat_DASeatTuneType',
                'value': null
              },
              {
                'name': '电动座椅记忆',
                'external_name': 'InStat_ElectricSeatMemory',
                'value': null
              },
              {
                'name': '前排座椅加热',
                'external_name': 'Heated_front_seats',
                'value': null
              },
              {
                'name': '后排座椅加热',
                'external_name': 'Heated_rear_seats',
                'value': null
              },
              {
                'name': '前排座椅通风',
                'external_name': 'The_front_seat_ventilation',
                'value': null
              },
              {
                'name': '后排座椅通风',
                'external_name': 'Rear_seat_ventilation',
                'value': null
              },
              {
                'name': '座椅按摩功能',
                'external_name': 'InStat_SeatKnead',
                'value': null
              },
              {
                'name': '第三排座椅',
                'external_name': 'InStat_3rdRowSeats',
                'value': null
              }
            ]
          },

          {
            'group_name': 'multimedia',
            'name': '多媒体配置',
            'params': [
              {
                'name': 'GPS导航系统',
                'external_name': 'InStat_GPS',
                'value': null
              },
              {
                'name': '中控台液晶屏',
                'external_name': 'InStat_CCEscreen',
                'value': null
              },
              {
                'name': '后排液晶屏',
                'external_name': 'InStat_BEscreen',
                'value': null
              },
              {
                'name': '蓝牙系统',
                'external_name': 'InStat_Bluetooth',
                'value': null
              },
              {
                'name': '无线上网功能',
                'external_name': 'InStat_WireLink',
                'value': null
              },
              {
                'name': '车载电视',
                'external_name': 'InStat_Video',
                'value': null
              },
              {
                'name': 'CD',
                'external_name': 'InStat_CDPlayer',
                'value': null
              },
              {
                'name': 'DVD',
                'external_name': 'InStat_DVDPlayer',
                'value': null
              }
            ]
          },

          {
            'group_name': 'light',
            'name': '灯光配置',
            'params': [
              {
                'name': '日间行车灯',
                'external_name': 'OutStat_DaytimeRunningLights',
                'value': null
              },
              {
                'name': '前大灯自动开闭',
                'external_name': 'OutStat_FLightClose',
                'value': null
              },
              {
                'name': '前雾灯',
                'external_name': 'OutStat_FfogLamp',
                'value': null
              },
              {
                'name': '前大灯自动清洗功能',
                'external_name': 'OutStat_FLightAutoClean',
                'value': null
              },
              {
                'name': '前大灯随动转向',
                'external_name': 'OutStat_FLightSteer',
                'value': null
              },
              {
                'name': '前大灯类型',
                'external_name': 'OutStat_FrontLightType',
                'value': null
              }
            ]
          },

          {
            'group_name': 'glass',
            'name': '玻璃/后视镜',
            'params': [
              {
                'name': '前电动车窗',
                'external_name': 'The_front_power_window',
                'value': null
              },
              {
                'name': '后电动车窗',
                'external_name': 'After_the_electric_window',
                'value': null
              },
              {
                'name': '外后视镜电动调节',
                'external_name': 'OutStat_ReMirrorElecTune',
                'value': null
              },
              {
                'name': '外后视镜加热功能',
                'external_name': 'OutStat_ReMirrorHot',
                'value': null
              },
              {
                'name': '内后视镜防眩目功能',
                'external_name': 'OutStat_ReMirrorDazzle',
                'value': null
              },
              {
                'name': '外后视镜电动折叠功能',
                'external_name': 'OutStat_ReMirrorFold',
                'value': null
              },
              {
                'name': '外后视镜记忆功能',
                'external_name': 'OutStat_ReMirrormemory',
                'value': null
              },
              {
                'name': '后窗遮阳帘',
                'external_name': 'OutStat_BackCurtain',
                'value': null
              },
              {
                'name': '后排侧遮阳帘',
                'external_name': 'OutStat_SecondRowCurtain',
                'value': null
              },
              {
                'name': '遮阳板化妆镜',
                'external_name': 'InStat_FaceMirror',
                'value': null
              },
              {
                'name': '后雨刷器',
                'external_name': 'OutStat_BBrushSensor',
                'value': null
              }
            ]
          },

          {
            'group_name': 'refrigeration',
            'name': '空调/冰箱',
            'params': [
              {
                'name': '空调控制方式',
                'external_name': 'InStat_AirCType',
                'value': null
              },
              {
                'name': '后排独立空调',
                'external_name': 'InStat_BAirCSystem',
                'value': null
              },
              {
                'name': '温度分区控制',
                'external_name': 'InStat_TemperSubCount',
                'value': null
              },
              {
                'name': '车载冰箱',
                'external_name': 'InStat_carFridge',
                'value': null
              }
            ]
          }
        ],
        'procedure': { // 手续信息
          'annualDue': '2018-12-27', // 年检日期
          'carInvoice': '有', // 新车发票
          'carWarranty': '过保', // 新车质保
          'commercialInsurance': '2018-03-27', // 商险到期日
          'drivingLicense': '有', // 有无行驶证
          'instructions': '有', // 说明书
          'key': '2', // 钥匙数量
          'maintenanceManual': '有', // 保养手册
          'freight': '', //  运费
          'mentionFee': '', // 提档费
          'transferFee': '1', // 过户费
          'newPlace': '1', // 迁往何处
          'proceduresSpend': '1', // 手续补办费用
          'purchaseTax': '1', // 购置税
          'registration': '有', // 登记证
          'strongInsurance': '2018-12-27', // 交强险到期日
          'transferRequest': '10', // 过户要求(天数)
          'transferTickets': '有', // 过户票
          'unHandleIllegal': '无' // 未处理违章
        }
      }
    }
  }
})
// 基本信息提交
Mock.mock(/\/used_car\/ticket\/car_info\/\d+/, 'post' + mockSwitch, {
  code: 0,
  message: 'ok',
  data: {
    is_details_ready: false // 是否完备
  }
})
